import React from "react";
import MainToolbar from "components/MainToolbar";
import {
  Flex,
  FlexRight,
  HorizontalSpacer,
  NavigationBar,
} from "components/styled";
import { VSpace } from "components/Spacer";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import { AddRegular, ArrowImportRegular } from "@fluentui/react-icons";
import { ExportExcelHandle } from "./InsurerReportEntriesGrid/ExportExcel";
import { useTranslation } from "react-i18next";
import { useInsurerReportsStore } from "store/InsurerReportsStore";
import { ResultsScore } from "components/ResultsScore";
import { RefreshButton } from "./InsurerReportsGrid/RefreshButton";
import InsurerReportsMenubar from "./InsurerReportsGrid/InsurerReportsMenubar";
import { ExportExcelButton } from "./InsurerReportsGrid/ExportExcelButton";
import { helpAnchor } from "help/anchor";

type Props = {
  refExcelExport: React.RefObject<ExportExcelHandle>;
};

const Navigation = ({ refExcelExport }: Props) => {
  const { t } = useTranslation();

  const [
    { insurerReportMetadataMap },
    { setInsurerReportsStoreValue },
  ] = useInsurerReportsStore();

  return (
    <>
      <NavigationBar style={{ zIndex: 333 }}>
        <MainToolbar
          pageName={"insurerReportsPage"}
          dataHelp={helpAnchor("insurer-reports-page-switcher")}
        />
        <RefreshButton />
        <InsurerReportsMenubar />
        <VSpace height={5} />
      </NavigationBar>
      <NavigationBar style={{ zIndex: 333 }}>
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <MenuButton
              data-help="insurer-reports-add-menu"
              appearance="subtle"
              icon={{ children: <AddRegular /> }}
            >
              {t("pct.addInsurerReport.label")}
            </MenuButton>
          </MenuTrigger>

          <MenuPopover>
            <MenuList>
              <MenuItem
                data-help="insurer-reports-import-menu-item"
                icon={{ children: <ArrowImportRegular /> }}
                onClick={() => {
                  setInsurerReportsStoreValue("importInsurerReportDialog", {
                    isOpen: true,
                  });
                }}
              >
                {t("pct.importInsurerReport.label")}
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
        <HorizontalSpacer width={10} />
        <ExportExcelButton refExcelExport={refExcelExport} />
        <FlexRight>
          <Flex>
            <ResultsScore
              dataHelp={helpAnchor("insurer-reports-results-count")}
              score={
                [
                  ...new Map(
                    Object.entries(insurerReportMetadataMap)
                  ).values(),
                ].filter((e: any) => {
                  return e.visible === true;
                }).length
              }
            />
          </Flex>
        </FlexRight>
      </NavigationBar>
    </>
  );
};

export default Navigation;
